const state = {
	savedData: null,
	config: null,
	frequencyUpdatesSaved: [],
	frequencyUpdatesSavedTotals: {}
}

export default state
